import * as constants from '../constants';

export const updateMapCenter = (payload: { lat: number; lng: number }) => ({
  type: constants.UPDATE_MAP_CENTER,
  payload,
});
